import React from 'react';
import { RotateCcw } from 'lucide-react';
import '../styles/orientation-lock.css';

/**
 * Full-screen overlay that asks the user to return to portrait when an
 * authenticated app screen is viewed in landscape on a phone.
 *
 * Web browsers can't force orientation in a normal tab (iOS Safari has no
 * Screen Orientation lock at all), so instead of letting the portrait-only
 * layout break, we cover it. Visibility is driven entirely by a CSS media
 * query — see orientation-lock.css.
 */
export default function OrientationLock() {
  return (
    <div className="orientation-lock" role="alertdialog" aria-label="Rotate your device to portrait">
      <div className="orientation-lock-content">
        <RotateCcw className="orientation-lock-icon" size={48} aria-hidden="true" />
        <p className="orientation-lock-title">Please rotate your device</p>
        <p className="orientation-lock-text">CrewCast works best in portrait mode.</p>
      </div>
    </div>
  );
}
